import React, { useEffect, useRef } from "react"
import './index.less'
import lottie from 'lottie-web'

interface Props {
  loadingText?: string
}

const LoadingMore = (props: Props) => {
  const lottieNode = useRef<any>(null)

  useEffect(() => {
    showLottie()
    return componentWillUnmount
  }, [])

  const componentWillUnmount = () => {
    lottie.destroy()
  }

  const showLottie = () => {
    lottie.destroy()
    import('./assets/loading.json').then((animationData) => {
      if (lottieNode.current) {
        lottie.loadAnimation({
          container: lottieNode.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
        });
      }
    })
  }

  return (
    <div className={'loadingMore'}>
      <div className={'loadingCont'} ref={item => { lottieNode.current = item }}></div>
      {
        props.loadingText ? <div className={'loadingText'}>{props.loadingText}</div> : null
      }
    </div>
  )
}

export default LoadingMore